import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, BookOpen, LogOut, Home, FileText } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    
    {
      path: '/dashboard',
      icon: <LayoutDashboard className="h-5 w-5" />,
      label: 'Dashboard',
    },
    {
      path: '/dashboard/free-quiz',
      icon: <BookOpen className="h-5 w-5" />,
      label: 'Free Quiz',
    },
    {
      path: '/dashboard/blog',
      icon: <FileText className="h-5 w-5" />,
      label: 'Blog Management',
    },
    {
      path: '/',
      icon: <Home className="h-5 w-5" />,
      label: 'Back to Site',
    },
  ];

  return (
    <div className="flex h-screen bg-gray-100 dark:bg-gray-900">
      {/* Sidebar */}
      <div
        className={`bg-white dark:bg-gray-800 shadow-lg transition-all duration-300 ${
          isCollapsed ? 'w-20' : 'w-64'
        } flex flex-col h-full`}
      >
        {/* Logo */}
        <div className="h-16 flex items-center justify-center border-b border-gray-200 dark:border-gray-700">
          <span className={`font-bold text-xl text-green-600 ${isCollapsed ? 'hidden' : 'block'}`}>
            Admin Panel
          </span>
        </div>

        {/* Navigation */}
        <nav className="mt-6 flex-1">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center px-6 py-3 text-gray-700 dark:text-gray-300 hover:bg-green-50 dark:hover:bg-gray-700 ${
                location.pathname === item.path
                  ? 'bg-green-50 dark:bg-gray-700 text-green-600 dark:text-green-400'
                  : ''
              }`}
            >
              {item.icon}
              {!isCollapsed && <span className="ml-3">{item.label}</span>}
            </Link>
          ))}
        </nav>

        {/* Logout Button as Sidebar Item */}
        <button
          onClick={handleLogout}
          className="flex items-center px-6 py-3 text-gray-700 dark:text-gray-300 hover:bg-red-50 dark:hover:bg-red-900/20 w-full text-left"
          aria-label="Logout"
        >
          <LogOut className="h-5 w-5" />
          {!isCollapsed && <span className="ml-3">Logout</span>}
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <div className="p-8">{children}</div>
      </div>
    </div>
  );
};

export default AdminLayout; 